//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { OrderbumpsContext } from "../context/OrderbumpsContext";



//--------------- EXPORTAÇÃO DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
export default function ContainerResumeCards() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { data, setData } = useContext(OrderbumpsContext); // Estado que armazena os Dados da busca feita pelo usuário



    //--------------- RETORNO CONDICIONAL DA PÁGINA ORDERBUMP RELATÓRIO ---------------//
    return (
        <>
            {!data?.resumo
                ? null
                :
                <>
                    <div className="grid md:grid-cols-4 gap-4 mb-6 w-full">
                        <div className="bg-surface-2 p-4 rounded-xl border border-brand-500 w-full">
                            <h3 className="text-brand-400 font-semibold mb-2">Produto Principal</h3>
                            <div>Produto: <b>{data.resumo.total_principal.nome}</b></div>
                            <div>Quantidade: <b>{data.resumo.total_principal.quantidade}</b></div>
                            <div>Total Valor: <b>R$ {data.resumo.total_principal.total_valor.toFixed(2)}</b></div>
                            <div>Total Produtor: <b>R$ {data.resumo.total_principal.total_valor_produtor.toFixed(2)}</b></div>
                        </div>

                        {data.resumo.total_orderbumps.map((bump, idx) => (
                            <div key={idx} className="bg-surface-2 p-4 rounded-xl border border-yellow-500 w-full">
                                <h3 className="text-yellow-400 font-semibold mb-2">Orderbump</h3>
                                <div>Produto: <b>{bump.nome}</b></div>
                                <div>Quantidade: <b>{bump.quantidade}</b></div>
                                <div>Total Valor: <b>R$ {bump.total_valor.toFixed(2)}</b></div>
                                <div>Total Produtor: <b>R$ {bump.total_valor_produtor.toFixed(2)}</b></div>
                            </div>
                        ))}

                        <div className="bg-surface-2 p-4 rounded-xl border border-green-500 w-full">
                            <h3 className="text-green-400 font-semibold mb-2">Total Geral</h3>
                            <div>Total Valor: <b>R$ {data.resumo.total_geral.total_valor.toFixed(2)}</b></div>
                            <div>Total Produtor: <b>R$ {data.resumo.total_geral.total_valor_produtor.toFixed(2)}</b></div>
                            <div>Investido: <b>R$ {data.resumo.total_geral.total_investido.toFixed(2)}</b></div>
                            <div className={data.resumo.total_geral.total_valor_produtor - data.resumo.total_geral.total_investido >= 0 ? "text-green-400" : "text-red-400"}>Lucro: <b>R$ {(data.resumo.total_geral.total_valor_produtor - data.resumo.total_geral.total_investido).toFixed(2)}</b></div>
                        </div>
                    </div>
                </>
            }
        </>
    );
}
